import React from 'react';

/** @param {{ children: React.ReactNode }} props */
export default function AdminFilterBar({ children }) {
  return <div className="admin-hub-kit-filter-bar">{children}</div>;
}
